interface Props {
  tabCount: number;
}

export function StatusBar({ tabCount }: Props) {
  return (
    <div
      style={{
        height: 22,
        background: 'var(--status-bar)',
        color: 'var(--status-text)',
        display: 'flex',
        alignItems: 'center',
        padding: '0 12px',
        fontSize: 11,
        gap: 14,
        flexShrink: 0,
        borderTop: '1px solid var(--border)',
      }}
    >
      <span>● Connected</span>
      <span>
        {tabCount} tab{tabCount === 1 ? '' : 's'}
      </span>
      <span style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 10 }}>
        <span>v2 · shell scaffold</span>
      </span>
    </div>
  );
}
